import { api } from '@/api'

export function assignOrderTypeToServiceAction(serviceSlug: string, orderTypePurchaseCuid: string) {
  return api.v2.patch(`/services/${serviceSlug}/order-types/${orderTypePurchaseCuid}`)
}
